import { SPACE_REGEXP } from '@constants';

export function getRegExpResults(
  regExp: RegExp,
  text: string | null,
) {
  const splittedText = text?.split(SPACE_REGEXP);
  const results = splittedText?.filter((i: string) =>
    i.match(regExp),
  );

  return results ?? [];
}
